import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const KeyboardKeyKIcon = ({ width, height, size }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? size ?? 10}
    height={height ?? size ?? 10}
    viewBox="0 0 6 8"
    fill="none"
  >
    <path
      d="M0.886475 5.28662L0.832764 3.89014H1.07983L4.47437 0.125H5.68823L2.48169 3.58936L2.03052 4.02441L0.886475 5.28662ZM0.0270996 7.87549V0.125H0.993896V7.87549H0.0270996ZM4.72144 7.87549L1.82642 4.01367L2.49243 3.34229L5.9729 7.87549H4.72144Z"
      fill="currentColor"
    />
  </svg>
)

export default KeyboardKeyKIcon
